'use strict';

/**
* @ngdoc service
* @name tcApp:ToastService
* @description
*/
angular.module('tcApp')
.service('ToastService', function($log, $mdToast, GlobalService) {
	var ToastService = this;
	
	// This variable is used to chain multiple toasts opening
	var toastPromise = null;

	/**
	* @ngdoc method
	* @name ToastService#show
	* @description
	* Displays a toast
	*
	* @param {!Object=} options Specific options object that may contain the
	*     following properties:
	*
	*	- `message` - `{string}`: Message to display in the toast, can also include HTML
	*	- `title` - `{string}`: Title to display on the toast
	*	- `type` - `{string}`: Type of toast to display, can be used to display different styles of toasts.
	*						   Currently supports 'error' type.
	*/
	this.show = function(options) {
		if (!angular.isObject(options)) {
			$log.warn('Invalid toast options');
			return;
		}
		if (toastPromise) {
			toastPromise.then(function() {
				ToastService.show(options);
			});
		} else {
			var toastConfig = {
				hideDelay: 4000,
				position: 'top center',
				templateUrl: 'template/toast/toast.html',
				locals: {
					message: options.message,
					title: options.title
				},
				toastClass: (angular.isDefined(options.type) ? options.type : ''),
				bindToController: true,
				controllerAs: 'toastCtrl',
				controller: function mdToastCtrl($sce) {
					var self = this;
					self.message = $sce.trustAsHtml(self.message);
				}
			};
			toastPromise = $mdToast.show(toastConfig)
				.then(function() {
					// Resolves when the toast closes
					toastPromise = null;
				});
			GlobalService.refreshNotifications();
		}
	};
});
